let DateTimeFormat = global.Intl.DateTimeFormat;

const capitalize = function (str) {
  if (str !== undefined && str !== null)
    return str.toLowerCase().replace(/(?:^|\s)\S/g, function (a) {
      return a.toUpperCase();
    });
  return "";
};

const normalize = (text) => {
  return text
    ? text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
    : "";
};

const numberFormatter = new Intl.NumberFormat("fr-FR", {
  maximumFractionDigits: 2,
});

const priceFormatter = new Intl.NumberFormat("fr-FR", {
  maximumFractionDigits: 0,
});

const momentFormatter = new Intl.NumberFormat("fr-FR", {
  minimumIntegerDigits: 2,
  maximumFractionDigits: 0,
});

const number = (value) => numberFormatter.format(value);
const price = (value) => priceFormatter.format(Math.round(value));

const currency = (value, curr = "€") =>
  `${numberFormatter.format(value)} ${curr}`;

const percent = (value) => `${numberFormatter.format(value * 100)}%`;

const formatDate = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return [("0" + day).slice(-2), ("0" + month).slice(-2), year].join("/");
};

const formatDatePlusHours = (date) => {
  const datePart = formatDate(date);
  return [
    datePart,
    " ",
    ("0" + date.getHours()).slice(-2),
    ":",
    ("0" + date.getMinutes()).slice(-2),
  ].join("");
};

const formatDatePost = (date) => {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  //had to put month before day due to joi validation server side
  return [("0" + month).slice(-2), ("0" + day).slice(-2), year].join("-");
};

const moment = (seconds) => {
  if (seconds === null || seconds === undefined) return "-";
  const s = seconds % 60;
  const m = (seconds - s) % 3600;
  const h = seconds - (s + m);
  const hh = momentFormatter.format(h / 3600);
  const mi = momentFormatter.format(m / 60);
  const ss = momentFormatter.format(s);
  return `${hh}:${mi}:${ss}`;
};

const getKindPrimaryText = (kind) => {
  switch (kind) {
    case "ASSU":
      return "Assurance";
    case "LIFT":
      return "Remontées mécaniques";
    case "ESF":
      return "ESF";
    case "HOT":
      return "Hébergement";
    case "TOURIST_TAX":
      return "Taxe de séjour";
    case "STAND":
      return "Autres produits";
    case "SKI_RENTAL":
      return "Location de matériel";
    case "TRANSFER":
      return "Transfert";
    case "FFS":
      return "Fédération Française de ski";
    default:
      return "Tous";
  }
};

const isEmailValid = (email) => {
  return email && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
};

const sorted = (column, descending) => {
  if (column) {
    return `${descending ? "-" : ""}${column}`;
  }
};

const bold = (text) => `<b>${text}</b>`;

const capitalizeEachWord = (str) => {
  return str.replace(
    /\w\S*/g,
    (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
  );
};

if (!Array.prototype.fill) {
  Object.defineProperty(Array.prototype, "fill", {
    value: function (value) {
      // Steps 1-2.
      if (this == null) {
        throw new TypeError("this is null or not defined");
      }

      var O = Object(this);

      // Steps 3-5.
      var len = O.length >>> 0;

      // Steps 6-7.
      var start = arguments[1];
      var relativeStart = start >> 0;

      // Step 8.
      var k =
        relativeStart < 0
          ? Math.max(len + relativeStart, 0)
          : Math.min(relativeStart, len);

      // Steps 9-10.
      var end = arguments[2];
      var relativeEnd = end === undefined ? len : end >> 0;

      // Step 11.
      var final =
        relativeEnd < 0
          ? Math.max(len + relativeEnd, 0)
          : Math.min(relativeEnd, len);

      // Step 12.
      while (k < final) {
        O[k] = value;
        k++;
      }

      // Step 13.
      return O;
    },
  });
}

const getString = (str) => {
  return str === null || str === undefined || str === "" ? undefined : str;
};

const getStringOrEmpty = (str) => {
  return str === null || str === undefined ? "" : str;
};

export {
  DateTimeFormat,
  capitalize,
  normalize,
  getKindPrimaryText,
  number,
  price,
  percent,
  formatDate,
  formatDatePlusHours,
  formatDatePost,
  moment,
  isEmailValid,
  currency,
  sorted,
  bold,
  capitalizeEachWord,
  getString,
  getStringOrEmpty,
};



// WEBPACK FOOTER //
// ./src/utils.js